// extracted by mini-css-extract-plugin
module.exports = {"content":"QSREmbedOrder_content__8u6PO","loading":"QSREmbedOrder_loading__fBDK1"};